var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastrConfirmWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52,
    viewBox: "0 0 57 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 47.84C57 49.192 56.5305 50.2233 55.5916 50.934C54.6527 51.6447 53.5004 52 52.1348 52H4.86523C3.49955 52 2.34726 51.636 1.40836 50.908C0.469452 50.18 0 49.1573 0 47.84C0 46.8 0.307278 45.7427 0.921833 44.668L24.531 2.86C25.6577 0.953333 26.9892 0 28.5256 0C30.062 0 31.3594 0.953333 32.4178 2.86L56.0782 44.72C56.6927 45.8293 57 46.8693 57 47.84ZM32.0593 21.268V13.676H24.9407V21.268C24.9407 21.7533 24.9748 22.2127 25.0431 22.646C25.1114 23.0793 25.2053 23.5647 25.3248 24.102C25.4443 24.6393 25.5382 25.0987 25.6065 25.48L26.938 33.904H29.9596L31.3423 25.48C31.4106 25.1333 31.513 24.6827 31.6496 24.128C31.7862 23.5733 31.8886 23.0793 31.9569 22.646C32.0252 22.2127 32.0593 21.7533 32.0593 21.268ZM32.0593 41.392C32.0593 40.3867 31.7093 39.5373 31.0094 38.844C30.3095 38.1507 29.4645 37.804 28.4744 37.804C27.5184 37.804 26.6905 38.1507 25.9906 38.844C25.2907 39.5373 24.9407 40.3867 24.9407 41.392C24.9407 42.3973 25.2907 43.2553 25.9906 43.966C26.6905 44.6767 27.5184 45.032 28.4744 45.032C29.4645 45.032 30.3095 44.6767 31.0094 43.966C31.7093 43.2553 32.0593 42.3973 32.0593 41.392Z",
    fill: "#F6BA2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastrConfirmWarning);
export default __webpack_public_path__ + "static/media/toastr-confirm-warning.58fe0830e961ba5b2158504c55fc6f00.svg";
export { ForwardRef as ReactComponent };